export const export_transformation_inline_tool = (lines: any, size_x: number, size_y: number) => {
    const point_tranformation = (array: any) => {
        return array.map((element: any, index: number) => {
            let number = 0
            if (index === 0) {
                number = element / size_x
                number = +number.toFixed(5)
                return number
            } else {
                number = element / size_y
                number = +number.toFixed(5)
                return number
            }
        })
    }
    const lines_submit = lines.map((element: any) => {
        return {
            ref: element.ref,
            point_a: point_tranformation(element.points[0]),
            point_b: point_tranformation(element.points[1])
        }
    })
    return lines_submit
}
